import React, { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Components & UI
import Header from "../Header";
import "../../css/WorkPage.css";
import { Container, Divider, Card, Link } from "@mui/material";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import AppsIcon from "@mui/icons-material/Apps";
import AboutMeSec from "../AboutMeSec";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

// Images (Keeping your imports...)
import DesignVerse from "../../images/DesignVerse2.png";
import CasperWeb from "../../images/CasperWeb2.png";
import LeonAgency from "../../images/LeonAgency2.png";
import GuessWord from "../../images/GuessWordGame2.png";
import ToDoApp from "../../images/ToDoApp2.png";
import weatherApp from "../../images/arab-capitales-weather.png";
import ecommerce from "../../images/ecommerce.png";
import yummyImage from "../../images/yummy-small.png";
import cosmicImage from "../../images/cosmic-small.png";
import adOnVerse from "../../images/adonversesmall2png.png";
import hamLegal from "../../images/hamlegalsmall.png";
import learnFlowSmall from "../../images/learnFlowSmall.png";
import AdOnVerseApp from "../../images/adonverseApp3.png";
// Contexts
import { useLoading } from "../../contexts/DisplayLoading";

const titleVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.8, ease: "easeOut" },
  }),
};

const projectVariants = {
  hidden: { opacity: 0, scale: 0.9, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: "spring", stiffness: 260, damping: 20 },
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    transition: { duration: 0.2 },
  },
};

export default function MyWork() {
  const [clickedWebType, setClickedWebType] = useState("all");
  const [showProjectsType, setShowProjectsType] = useState("cards");
  const [width, setWidth] = useState(window.innerWidth);

  const { loading, DisplayLoading } = useLoading();
  DisplayLoading();

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const finalView = width <= 930 ? "cards" : showProjectsType;
  const isSmallScreen = width <= 930;

  const myProjects = useMemo(
    () => [
      {
        id: "adOnVerseApp",
        name: "AdonVerse App",
        services: "Devolpment",
        Languages: "Next | JS | Kotlin ",
        type: "webApp",
        image: AdOnVerseApp,
        link: "https://play.google.com/store/apps/details?id=com.adonverse.adonverseapp&hl=en",
      },
      {
        id: "adOnVerse",
        name: "AdonVerse.com",
        services: "Devolpment",
        Languages: "Next | JS | Css ",
        type: "webPage",
        image: adOnVerse,
        link: "https://www.adonverse.com",
      },
      {
        id: "hamlegal",
        name: "Ham Legal",
        services: "Devolpment",
        Languages: "wordPress",
        type: "webPage",
        image: hamLegal,
        link: "https://hamlegal.net/",
      },
      {
        id: "clothes-ecommerce",
        name: "SHOP.CO",
        services: "Devolpment",
        Languages: "React | JS | Tailwind/Css | Redux",
        type: "webPage",
        image: ecommerce,
        link: "https://clothes-ecommerce-jr.netlify.app/",
      },
      {
        id: "Yummy",
        name: "Yummy",
        services: "Devolpment",
        Languages: "Next | JS | Css ",
        type: "webPage",
        image: yummyImage,
        link: "https://yummy-food-chi.vercel.app/",
      },
      {
        id: "cosmic-fish",
        name: "Cosmic Fishing",
        services: "Devolpment",
        Languages: "Next | JS | Css/TailWind | pwa",
        type: "webPage",
        image: cosmicImage,
        link: "https://cosmic-fishing.vercel.app/",
      },
      {
        id: "design-verse",
        name: "DesignVerse",
        services: "Devolpment",
        Languages: "HTML | CSS",
        type: "webPage",
        image: DesignVerse,
        link: "https://taim-gr.github.io/DesignVerse/",
      },
      {
        id: "casper-web",
        name: "CasperWeb",
        services: "Devolpment",
        Languages: "HTML | CSS",
        type: "webPage",
        image: CasperWeb,
        link: "https://taim-gr.github.io/Casper/",
      },
      {
        id: "LearnFlow",
        name: "Learn Flow",
        services: "Devolpment",
        Languages: "React | CSS | JS",
        type: "webPage",
        image: learnFlowSmall,
        link: "https://learn-flow-rouge.vercel.app/",
      },
      {
        id: "leon-agency",
        name: "LeonAgency",
        services: "Devolpment",
        Languages: "HTML | CSS",
        type: "webPage",
        image: LeonAgency,
        link: "https://taim-gr.github.io/Leon-agency-web/",
      },
      {
        id: "to-do-app",
        name: "Todo App",
        services: "Devolpment",
        Languages: "React | CSS",
        type: "webApp",
        image: ToDoApp,
        link: "https://todo-jr.netlify.app/",
      },
      {
        id: "guess-word",
        name: "Guess The Word",
        services: "Devolpment",
        Languages: "HTML | CSS | JS",
        type: "webApp",
        image: GuessWord,
        link: "https://taim-gr.github.io/Guess-The-Word-Game/",
      },
      // {
      //   id: "prayer-times",
      //   name: "Syria Prayer Times",
      //   services: "Devolpment",
      //   Languages: "React | Tailwind/Css | JS",
      //   type: "webApp",
      //   image: PrayerTimes,
      //   link: "https://syria-prayer-times.netlify.app/",
      // },
      {
        id: "weather-app",
        name: "Arab Capitals Weather",
        services: "Devolpment",
        Languages: "React | Css | JS | Redux",
        type: "webApp",
        image: weatherApp,
        link: "https://arab-capitals-weather.netlify.app/",
      },
    ],
    [],
  );
  const fader = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 },
    },
  };
  const filteredProjects = useMemo(() => {
    return clickedWebType === "all"
      ? myProjects
      : myProjects.filter((pr) => pr.type === clickedWebType);
  }, [clickedWebType, myProjects]);

  return (
    <div
      style={{
        backgroundColor: loading.isVisible ? "black" : "white",
        minHeight: "100vh",
      }}
    >
      {!loading.isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Header
            headerColor="black"
            hoverColor="black"
            shadowColor="transparent"
          />

          {/* Updated Animated Headline to match AboutMe Style */}
          <Container
            className="title-container-work"
            maxWidth="lg"
            sx={{ padding: isSmallScreen ? "60px 20px" : "120px 20px 60px" }}
          >
            <motion.div
              variants={staggerContainer}
              initial="hidden"
              animate="visible"
            >
              <motion.h1
                variants={fader}
                style={{
                  fontSize: "clamp(40px, 8vw, 85px)",
                  fontWeight: "800",
                  lineHeight: "1",
                  marginBottom: "0",
                  textAlign: isSmallScreen ? "center" : "left",
                }}
              >
                {!isSmallScreen && (
                  <AutoAwesomeIcon
                    sx={{ fontSize: "40px", verticalAlign: "middle", mr: 2 }}
                  />
                )}
                CREATING MODERN
              </motion.h1>

              <motion.h1
                className="headline"
                variants={fader}
                style={{
                  fontSize: "clamp(40px, 8vw, 85px)",
                  fontWeight: "800",
                  lineHeight: "1",
                  paddingLeft: isSmallScreen ? "0" : "15%",
                  color: "#455CE9", // Matches the AboutMe blue accent
                  textAlign: isSmallScreen ? "center" : "left",
                }}
              >
                WEBSITES THAT
              </motion.h1>

              <motion.h1
                className="headline"
                variants={fader}
                style={{
                  fontSize: "clamp(40px, 8vw, 85px)",
                  fontWeight: "800",
                  lineHeight: "1",
                  paddingLeft: isSmallScreen ? "0" : "30%",
                  textAlign: isSmallScreen ? "center" : "left",
                }}
              >
                INSPIRE BRANDS
                {!isSmallScreen && (
                  <AutoAwesomeIcon
                    sx={{ fontSize: "40px", verticalAlign: "middle", ml: 2 }}
                  />
                )}
              </motion.h1>
            </motion.div>
          </Container>

          {/* Filter Controls (Unchanged as requested) */}
          <Container
            className="organize-projects"
            maxWidth="lg"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="web-type" style={{ display: "flex", gap: "10px" }}>
              {["all", "webPage", "webApp"].map((type) => (
                <button
                  key={type}
                  className={`filter-btn ${clickedWebType === type ? "active" : ""}`}
                  onClick={() => setClickedWebType(type)}
                  style={{
                    backgroundColor:
                      clickedWebType === type ? "black" : "white",
                    color: clickedWebType === type ? "white" : "black",
                    border: "1px solid black",
                    padding: "8px 20px",
                    cursor: "pointer",
                    borderRadius: "25px",
                    transition: "0.3s",
                    fontSize: isSmallScreen ? "12px" : "14px", // Slightly smaller font for mobile
                  }}
                >
                  {type === "all"
                    ? "All"
                    : type === "webPage"
                      ? "Web Pages"
                      : "Web Applications"}
                </button>
              ))}
            </div>

            {width > 1000 && (
              <div
                className="order-web-icons"
                style={{ display: "flex", gap: "5px" }}
              >
                <button
                  onClick={() => setShowProjectsType("Horiz")}
                  style={{
                    background: finalView === "Horiz" ? "black" : "white",
                    color: finalView === "Horiz" ? "white" : "black",
                    border: "1px solid black",
                    cursor: "pointer",
                  }}
                >
                  <DensitySmallIcon />
                </button>
                <button
                  onClick={() => setShowProjectsType("cards")}
                  style={{
                    background: finalView === "cards" ? "black" : "white",
                    color: finalView === "cards" ? "white" : "black",
                    border: "1px solid black",
                    cursor: "pointer",
                  }}
                >
                  <AppsIcon />
                </button>
              </div>
            )}
          </Container>

          <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Divider />

            {/* Project List Header (Desktop Only) */}
            {finalView === "Horiz" && (
              <div
                style={{
                  display: "flex",
                  padding: "25px 0",
                  color: "#7e7777",
                  fontWeight: "bold",
                }}
              >
                <span style={{ flex: 1, textAlign: "center" }}>Name</span>
                <span style={{ flex: 1, textAlign: "center" }}>Services</span>
                <span style={{ flex: 1, textAlign: "center" }}>Languages</span>
              </div>
            )}

            <motion.div
              layout
              className="projects-display-area"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                padding: isSmallScreen ? "30px 0" : "60px 0",
                minHeight: "400px",
              }}
            >
              <AnimatePresence mode="popLayout">
                {filteredProjects.map((pr) => (
                  <motion.div
                    key={pr.id}
                    layout
                    variants={projectVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    style={{
                      // Responsive Width: 100% on mobile/iPad, 50% on Desktop
                      width: isSmallScreen
                        ? "100%"
                        : finalView === "Horiz"
                          ? "100%"
                          : "calc(50% - 10px)",
                    }}
                  >
                    {finalView === "Horiz" ? (
                      <div
                        className="site-container-row"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "20px 0",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <Link
                          href={pr.link}
                          target="_blank"
                          underline="none"
                          sx={{
                            flex: 1,
                            textAlign: "center",
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                          }}
                        >
                          {pr.name}
                        </Link>
                        <h3
                          style={{
                            flex: 1,
                            textAlign: "center",
                            fontSize: "1rem",
                          }}
                        >
                          {pr.services}
                        </h3>
                        <h3
                          style={{
                            flex: 1,
                            textAlign: "center",
                            fontSize: "1rem",
                          }}
                        >
                          {pr.Languages}
                        </h3>
                      </div>
                    ) : (
                      <motion.div
                        whileHover={isSmallScreen ? {} : { scale: 1.02 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 10,
                        }}
                      >
                        <Card
                          sx={{
                            padding: "2px",
                            cursor: "pointer",
                            borderRadius: "15px",
                            overflow: "hidden",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          }}
                        >
                          <Link href={pr.link} target="_blank" underline="none">
                            <img
                              src={pr.image}
                              alt={pr.name}
                              style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                              }}
                            />
                            <div
                              style={{
                                padding: isSmallScreen ? "15px" : "25px",
                              }}
                            >
                              <h2
                                style={{
                                  color: "black",
                                  margin: 0,
                                  fontSize: isSmallScreen ? "1.2rem" : "1.5rem",
                                }}
                              >
                                {pr.name}
                              </h2>
                            </div>
                          </Link>
                        </Card>
                      </motion.div>
                    )}
                  </motion.div>
                ))}
              </AnimatePresence>
            </motion.div>
          </Container>

          <AboutMeSec />
        </motion.div>
      )}
    </div>
  );
}
